import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import FormLink from "../../../../../library/form/components/FormLink";
import HoldStatus from "../../../components/HoldStatus";
import FormMenu from '../../../../../library/form/components/FormMenu';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColThree, UiCol } from "../../../../../library/layout/Index";

const ProdTaskHeader = (props) => {
    const { formObject, viewData, selectedTask, setSelectedTask } = props;

    //reset the id of the current task after it is deleted
    const onDeleteTaskSuccess = () => {
        if(setSelectedTask) setSelectedTask(0);
    }

    if (!viewData)
        return (null);

    return (
        <UiView >
            <UiViewHeading>
                <UiTitle>
                    <div className="uiFlexBox">
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "processName" }} />
                    <FormROValue className="uiChip" formObject={formObject} rowKey="" action={{ paramName: 'status' }} />
                    <HoldStatus viewData={formObject.childViews.holdStatus} />
                    </div>
                </UiTitle>
                
                <UiAction>
                    <FormButton formObject={formObject} rowKey="" className="uiDeleteIconButton" starIcon="delete"
                        onlyIcon={true}
                        starIconClassName="uiColorNegativeAction"
                        tooltip="Delete Task"
                        action={{ actionId: "del", 
                        refreshMode: "dep",
                        onSuccess: onDeleteTaskSuccess,
                        paramName: "deleteTask", actionParam: { actionType: "deleteTask" } }} text={<SarasTrans value="Delete" />} />
                    <div className="uiInline uiSpacerH10"></div>
                    <FormButton formObject={formObject} rowKey="" className="uiApproveIconButton" starIcon="approve"
                        onlyIcon={true}
                        starIconClassName="uiColorApproveAction"
                        tooltip="Approve Task"
                        confirm="Are you sure to Approve the Task"
                        action={{ actionId: "refresh", 
                        refreshMode: "dep",
                        paramName: "approveTask", actionParam: { actionType: "approveTask" } }} text={<SarasTrans value="Approve" />} />
                    <FormButton formObject={formObject} rowKey="" className="uiRejectIconButton" starIcon="reject"
                        onlyIcon={true}
                        starIconClassName="uiColorRejectAction"
                        tooltip="Reject Task"
                        confirm="Are you sure to Reject the Task"
                        action={{ actionId: "refresh", 
                        refreshMode: "dep",
                        paramName: "rejectTask", actionParam: { actionType: "rejectTask" } }} text={<SarasTrans value="Reject" />} />
                    <div className="uiInline uiSpacerH10"></div>
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="issue"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Issue Material"
                        text={<SarasTrans value="Issue Material" />}
                        action={{ actionId: "refresh", paramName: "issueMat", actionParam: { rowKey: selectedTask, actionType: "issueTaskDetail", pathKey: "TISS" }, containerKey: "popup" }}  />
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton"  starIcon="issue"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Issue More Material"
                        text={<SarasTrans value="Issue More" />}
                        action={{ actionId: "refresh", paramName: "issueMore", actionParam: { rowKey: selectedTask, actionType: "issueTaskDetail", pathKey: "TISS" }, containerKey: "popup" }}  />
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="return" 
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Return Material"
                        text={<SarasTrans value="Return Material" />}
                        action={{ actionId: "refresh", paramName: "returnMat", actionParam: {rowKey: selectedTask, actionType: "returnTaskDetail", pathKey: "TRET"}, containerKey: "popup" }}  />
                    <FormMenu formObject={formObject}
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                                directForSingle="1"
                                rowKey="" tooltip='Print' headerKey='print' starIcon={'print'}
                                action={{}}
                                className="uiActionIconButton" />
                    <div className="uiInline uiSpacerH10"></div>
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="timesheet"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Timesheet"
                        action={{ actionId: "show", paramName: "timesheetBtn", actionName: "projectTS", actionParam: { rowKey: selectedTask }, containerKey: "popup" }} text={<SarasTrans value="Timesheet" />} />
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon="hold"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Hold / Resume"
                        action={{ actionId: "new", actionName: "projectHold", paramName: "holdResumeBtn", 
                        actionParam: { actionType: "holdResumeTask", rowKey: selectedTask }, containerKey: "popup" }} 
                        text={<SarasTrans value="Hold / Resume" />} />
                    <div className="uiInline uiSpacerH10"></div>
                    <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" text={<SarasTrans value="Recalculate Cost" />}
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        tooltip="Recalculate Cost" starIcon="cost"
                        confirm="Recalculate order cost ?" action={{ actionId: "refresh", paramName: "recalculateCost", 
                        actionMessage:"Recalculate task card", actionParam: {rowKey: selectedTask, actionType: "recalculateCost"}}}  />
                    <div className="uiInline uiSpacerH5"></div>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColThree>
                    <UiCol>
                        <ul>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Profile" />
                                </span>
                                <FormInput  formObject={formObject} rowKey="" className="uiInput" format="#"
                                    action={{
                                        InputType: "ac", paramName: "profile", acMethod: "ProfileName", actionId: "refresh",
                                        refreshMode: "dep",
                                        actionParam: { actionType: "changeAllocation" }, acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                    }}
                                />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reqOutsourcing" }} value="Is OutSourced" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey="" action={{
                                    InputType: "onOff",
                                    refreshMode: "dep",
                                    paramName: "reqOutsourcing", actionId: "refresh", actionParam: { actionType: "changeOutsourcing" }
                                }} />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reqOh" }} value="Have OH" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey="" action={{
                                    InputType: "onOff",
                                    refreshMode: "dep",
                                    paramName: "reqOh", actionId: "refresh", actionParam: { actionType: "changeReqOh" }
                                }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "soStatus" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "soStatus" }} value="SO Status" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'soStatus' }} className='uiLbl uiDisplayInline' />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "soContainer" }} >
                                <span className="uiLbl">
                                    <SarasTrans value="Service Order" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{
                                        paramName: "sOrderId",
                                        actionId: "show",  actionName: "invcomp",
                                        containerKey: "popup"
                                    }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                                    action={{ actionId: "refresh", paramName: "createSO", actionParam: { actionType: "createSO"} }} text={<SarasTrans value="Create SO" />} />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isHelperTask" }} value="Is Helper Task" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey="" action={{
                                    InputType: "onOff",
                                    refreshMode: "dep",
                                    paramName: "isHelperTask", actionId: "refresh", actionParam: { actionType: "changeIsHelperTask" }
                                }} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty" }} value="Qty" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'qty' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedOn" }} value="Issued On" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'issuedOn' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "returnOn" }} value="Return On" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'returnOn' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "workingHrs" }} value="Working Hours" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'workingHrs' }} />
                                <span className="uiSpacerL5"><SarasTrans value="(HH:MM)" /></span>
                            </li>
                            <li>
                                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                                        action={{ actionId: "refresh", actionName: "prodDeduction", paramName: "genDeductionSlip", actionParam: {actionType: "genDeductionSlip", showModeID: 'sh', tdtId: "70103" }, containerKey:"popup"} } text={<SarasTrans value="Generate Deduction Slip" />} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processCost" }} value="Process Cost" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'processCost' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "resourceCost" }} value="Resource Cost" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'resourceCost' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ohCost" }} value="OH Cost" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'ohCost' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalCost" }} value="Total Cost" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'totalCost' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskComment" }} value="Comment" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'taskComment' }} />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColThree>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdTaskHeader, "prodTaskHeader", "prodTaskList");